//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Btn from '../components/Btn.vue';
import IconArrow from '../components/IconArrow.vue';
import PageOverlay from '../components/PageOverlay.vue';
import FeedbackForm from '../components/FeedbackForm.vue';

export default {
	name: 'FeedbackTile',

	components: { Btn: Btn, IconArrow: IconArrow, PageOverlay: PageOverlay, FeedbackForm: FeedbackForm },
	props: {
		ya_metrica_goal: {
			type: String,
			default: ''
		}

	},
	data: function data() {
		return {
			overlayIsShow: false,
			formIsClear: false
		};
	},


	computed: {
		content: function content() {
			return this.$store.state.settings.feedbackTile || {};
		}
	},

	methods: {
		openOverlay: function openOverlay() {
			this.overlayIsShow = true;
			return false;
		},
		closeOverlay: function closeOverlay() {
			this.overlayIsShow = false;
			this.formIsClear = true;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FeedbackTile.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FeedbackTile.vue
// module chunks = 0 1 2